import { useEffect, useState } from "react";
import { reload, useChatStore } from "../../../store/ChatStore";
import { User } from "../../../../imsdk/db/t_user";
import { postJson } from "../../../net/http";
import { TopicUserListRender } from "../TopicUsers";
import { Str_AddMembers, Str_DelMember } from "../../../language/string_res";
import { MainNavProps } from "../../navigation/main/MainParamList";
import { useIsFocused } from "@react-navigation/native";
import * as ImSdk from "../../../../imsdk/api";
import { showToast } from "../../../components/Toast";
import { ScreenModal } from "../../../components/ScreenModal";
import { isSystemAcc } from "../CListItem";
import { hideLoading, showLoading } from "../../../components/Loading";

export const GroupRemoveOrAddUser = ({
  navigation,
  route,
}: MainNavProps<"GroupRemoveOrAddUser">) => {
  const isRemove = route.params.isRemove;
  const [users, updateUsers] = useState<User[]>([]);
  const { chatState, chatDispatch } = useChatStore();
  const members = chatState.curTopicWithSummary.users ?? [];
  const group = chatState.curTopicWithSummary.group;
  const tid = chatState.curTopicWithSummary.topic.tid;
  const adminSet = chatState.adminSet ?? new Set<number>([]);
  const currentUid = ImSdk.getInstance().CurrentUid();
  const isFoucused = useIsFocused();
  const initRemoveUserList = () => {
    const ctrlUsers: User[] = [];
    members.forEach((v) => {
      if (v.uid === currentUid) {
        // 不能删自己
        // console.log("不能删自己", v.uid);
        return;
      }
      if (v.uid === group?.uid) {
        // console.log("不能删群主", v.uid);
        return;
      }
      if (currentUid === group?.uid) {
        // 群主可以删所有人
        ctrlUsers.push(v as any as User);
        return;
      }
      if (adminSet.has(currentUid)) {
        // 管理员只能删普通用户
        if (!adminSet.has(v.uid)) {
          ctrlUsers.push(v as any as User);
          return;
        } else {
          return;
        }
      }
    });
    updateUsers(ctrlUsers);
  };

  async function fetchTopicMembers(tid: string) {
    try {
      const res = await postJson<{ members: number[] }>(
        "/v1/sdk/group/detail",
        {
          body: { tid },
        }
      );
      return res.data?.members || [];
    } catch {
      return [] as number[];
    }
  }

  async function initAddUserList() {
    const im = ImSdk.getInstance();
    // 如果我是P，那么我可以拉取所有人:
    const r = await im.GetContact({ isfriend: 1 });
    const contacts = r.users || [];
    // 如果我是F和B，那么我只能拉取同事和P
    // 查本地的数据库
    // 好友、同事、供应链关系 并且不能在当前的群里面
    if (tid.startsWith("g_")) {
      const members = await fetchTopicMembers(tid);
      const set = new Set(members || []);
      const newusers = contacts.filter(
        (v) => v.status !== "deleted" && !set.has(v.uid) && !isSystemAcc(v.uid)
      );
      updateUsers(newusers);
    } else {
      const newusers = contacts.filter((v) => v.status !== "deleted");
      updateUsers(newusers);
    }
  }

  useEffect(() => {
    if (isFoucused) {
      isRemove ? initRemoveUserList() : initAddUserList();
    }
  }, [isFoucused]);

  function handleRemoveSubmit(members: number[]) {
    showLoading();
    postJson("/v1/sdk/group/kick", {
      body: { tid: tid, uids: members },
    }).then((res) => {
      hideLoading()
      if (!res.code && members && members.length > 0) {
        reload(tid, chatDispatch);
        onClose();
      } else {
        res.msg && showToast(res.msg);
      }
    }).catch(() => {
      hideLoading();
    });
  }

  function handleAddSubmit(members: number[]) {
    postJson("/v1/sdk/group/apply/add", {
      body: { tid: tid, members },
    }).then((res) => {
      if (!res.code) {
        reload(tid, chatDispatch);
        onClose();
      } else {
        res.msg && showToast(res.msg);
      }
    });
  }
  const onClose = () => {
    navigation.goBack();
  };
  return (
    <TopicUserListRender
      title={isRemove ? Str_DelMember : Str_AddMembers}
      users={users}
      onClose={onClose}
      onSubmit={isRemove ? handleRemoveSubmit : handleAddSubmit}
      hasRadio={true}
    />
  );
};
